import { HOSTED_PAYMENTS_URL } from '../../constants';

const getPaymentUrl = (transactionSetupId: string) => {
  return `${HOSTED_PAYMENTS_URL}/?TransactionSetupID=${transactionSetupId}`;
};

export default getPaymentUrl;
